import React, {
	FC, useState, useMemo, useContext, createContext, ReactNode,
} from 'react';

interface TitleBarContextProps {
   title?: string | ReactNode | null;
   setTitle: (user: string | ReactNode | null) => void;
   setGlobalLoading: (loading: boolean) => void;
   loading: boolean
}

const TitleBarContext = createContext({} as TitleBarContextProps);

export const TitleBarProvider: FC = ({ children }) => {
	const [title, setTitle] = useState<string | ReactNode | null>();
	const [loading, setGlobalLoading] = useState(false);

	const value = useMemo(() => ({
		title, setTitle, setGlobalLoading, loading,
	}), [title, loading, setGlobalLoading]);
	return <TitleBarContext.Provider value={value}>{children}</TitleBarContext.Provider>;
};

export default function useTitleBar() {
	return useContext(TitleBarContext);
}
